import actionTypes from "../../actions/index";

const initialState = {
  data: {},
  login: {},
};

const LoginReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GENERATE_OTP:
      return {
        ...state,
        data: action.payload,
      };

    case actionTypes.RESET_OTP:
      return {
        ...state,
        data: {},
      };

    case actionTypes.LOGIN:
      return {
        ...state,
        login: action.payload,
      };

      case actionTypes.RESET_LOGIN:
        return {
          ...state,
          login: {},
        };

    default:
      return state;
  }
};
export default LoginReducer;
